/*
 * @Author: qinzhang14
 * @Date: 2021-11-29 10:23:56
 * @LastEditTime: 2022-04-29 17:18:27
 * @LastEditors: shangao
 * @Description: 路由
 * @FilePath: \teaching-web\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import ManageLayout from '@/layouts/ManageLayout'

Vue.use(VueRouter)
const routes = [
  { path: '/', redirect: 'home' },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home')
  },
  {
    path: '/archive',
    name: 'archive',
    component: () => import('@/views/archive')
  },
  {
    path: '/archive-detail',
    name: 'archiveDetail',
    component: () => import('@/views/archive-detail/detail-page.vue')
  },
  {
    path: '/streaming',
    name: 'streaming',
    component: () => import('@/views/streaming')
  },
  {
    path: '/live',
    name: 'live',
    component: () => import('@/views/live/index.vue')
  },
  {
    path: '/manage',
    component: ManageLayout,
    children: [
      {
        path: '/manage/course',
        name: 'ManageCourse',
        meta: { index: '0101', title: '课程管理' },
        component: () => import('@/views/manage/course.vue')
      },
      {
        path: '/manage/course/create',
        name: 'ManageCourseCreate',
        meta: { index: '010101', invisible: true, title: '新增' },
        component: () => import('@/views/manage/modify.vue')
      },
      {
        path: '/manage/comment',
        name: 'ManageComment',
        meta: { index: '0102', title: '评论管理' },
        component: () => import('@/views/manage/comment.vue')
      },
    ]
  },
  // {
  //     path: '/manage',
  //     name: 'ManageList',
  //     component: () => import('@/views/manage/list.vue')
  // },
  // {
  //     path: '/manageModify',
  //     name: 'ManageModify',
  //     component: () => import('@/views/manage/modify.vue')
  // }
]
const router = new VueRouter({
  routes 
  
})
export default router
